export class ReportQuery {
  interval?: string;
  startDate?: string;
  endDate?: string;
  name?: string;
  date?: string;
}
